import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    items: [],
    showShoppingCart: false,
    currency: { symbol: "$", pattern: "!#" }
  },
  actions,
  getters,
  mutations
};
